import script from "./Dispute.vue?vue&type=script&setup=true&lang=js"
export * from "./Dispute.vue?vue&type=script&setup=true&lang=js"

import "./Dispute.vue?vue&type=style&index=0&id=3fb21002&lang=css"

const __exports__ = script;

export default __exports__